const days = [
  { day: 1, name: 'segunda-feira', status: !1, times: [] },
  { day: 2, name: 'terça-feira', status: !1, times: [] },
  { day: 3, name: 'quarta-feira', status: !1, times: [] },
  { day: 4, name: 'quinta-feira', status: !1, times: [] },
  { day: 5, name: 'sexta-feira', status: !1, times: [] },
  { day: 6, name: 'sábado', status: !1, times: [] },
  { day: 0, name: 'domingo', status: !1, times: [] }
]

export default async (args = {}) => {
  const list = [], r = await axios.get('site/horarios');
  days.filter((item) => {
    let { day, name, status } = item,
      add = !1
    const _times = []
    r.filter((t) => {
      if (day.toString() === t.day.toString()) {
        _times.push({
          start: t.start,
          end: t.end,
          error: '',
          remove: !0
        })
      }
    })
    status = _times.length > 0
    if (_times.length > 0) {
      if (_times.length === 1) {
        _times[0].remove = !1
      }
      add = !0
    }
    list.push({ day, name, times: _times, add, status })
  })
  let txt = '<table class="mb-3"><tbody>';
  list.forEach(item => {
    txt += `
<tr class="${item.status ? 'active font-weight-black' : 'transp'}">
  <td class="px-2 align-middle text-capitalize">
    ${item.name}
  </td>`
    if (item.status) {
      txt += `<td class="px-1 align-middle text-center">`
      item.times.forEach((time, _idx) => {
        txt += `<span>${time.start}-${time.end}`
        if (item.times.length > 1 && _idx < 1) {
          txt += `<span class="mx-2">e</span>`
        }
        txt += `</span>`
      })
      txt += `</td>`
    }
    else {
      txt += `<td class="align-middle text-center">Fechado</td>`
    }
    txt += `</tr>`
  });
  txt += '</tbody></table>'

  return '<p class="font-weight-black error--text">Confira nosso horário de funcionamento:</p>' + txt

}
